<h1 mat-dialog-title>
  {{title}}
</h1>
 
<div mat-dialog-content>
  <p>{{message}}</p>

  <div *ngIf="hasForm" class="mt-4">
    <mat-form-field>
      <input matInput 
          name="frmField" 
          [(ngModel)]="fieldValue" 
          placeholder="{{fieldName}}" 
          >
    </mat-form-field>
  </div>


  <div *ngIf="isRecurrent" class="container-toggle mt-3 mb-3">
    <mat-button-toggle-group [(ngModel)]="selectedOption" #group="matButtonToggleGroup">
        <mat-button-toggle value="opcion1">Reserva única</mat-button-toggle>
        <mat-button-toggle value="opcion2">Grupo de reserva</mat-button-toggle>
    </mat-button-toggle-group>
  </div> 

</div>
 
<div mat-dialog-actions align="end">
  <button mat-button (click)="onDismiss()">No</button>
  <button mat-raised-button color="primary" (click)="onConfirm()">Sí</button>
</div>
